import { DimensionSettings } from './types';

export const CLASS_OPEN = 'is-bundle-builder-open';
const generateMarkup = props => {
  const { min_drop, max_drop, min_width, max_width } = props;
  const template = document.createElement('template');

  template.innerHTML = `
    <style>
      :host {
        width: 100%;
      }

      :root {
        
      }

      input {
        font-family: 'TTNorms Font', Helvectica, sans-serif;
        height: 3.125rem;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        margin-bottom: 1rem;
        outline: none;
        border-radius: 1rem;
        border: 1px solid transparent;
        color: #163021;
        font-size: .875rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: .0175rem;
        transition: all 300ms;
      }

      input::placeholder {
        color: rgba(22, 48, 33, 0.30);
      }

      input:hover,
      input:active,
      input:focus {
        border-color: #163021;
      }

      .customiser-size-picker {
        display: flex;
        flex-direction: column;
      }

      input:not(:placeholder-shown):not(:valid),
      input:placeholder-shown.is-invalid {
        border: 1px solid #c84242;
      }

      input:valid + .o-form__label-text + .o-form__input-validation {
        display: none;
      }

      input:placeholder-shown:not(.is-invalid) + .o-form__label-text + .o-form__input-validation {
        display: none;
      }

      .o-form__input-validation {
        color: #c84242;
        padding: .5rem 1rem 0;
        border-radius: .5rem;
        font-size: .875rem;
        font-weight: 500;
        line-height: 1.25rem;
        letter-spacing: .0175rem;
        margin: -.5rem 0 1.25rem;
      }

      .o-form__label {
        position: relative;
        display: flex;
        width: 100%;
        flex-direction: column;
      }

      .o-form__label input {
        flex: 1 1 auto;
      }

      @media only screen and (min-width: 1100px) {

        :host {
          
        }

        input:not(:placeholder-shown):not(:valid),
        input:placeholder-shown.is-invalid {
          margin-top: 0;
        }

        .customiser-size-picker {
          flex-direction: row;
          padding-top: 1rem;
        }

        .o-form__label input {
          flex: unset;
        }

        .o-form__label {
          flex: 0 0 calc(33.33337% - 1rem);
          margin-right: 1rem;
        }
          
        input {
          padding-left: 2rem;
          padding-right: 2rem;
          font-size: 1rem;
          letter-spacing: .02rem;
        }
      }

      @media only screen and (max-width: 1099px) {
        input:not(:placeholder-shown) {
          margin-top: 2rem;
        }
      }


      @media only screen and (min-width: 1750px) {
        input {
          font-size: 1.125rem;
          height: 4rem;
        }
      }



      .o-form__label {
        position: relative;
        display: flex;
        flex-direction: column;
        padding-top: 0;
        transition: all 0.6s;
      }
      .o-form__label-text {
        position: absolute;
        top: 1rem;
        left: 1.5rem;
        z-index: 1;
        font-family: "TTNorms Font", Helvectica, sans-serif;
        font-weight: 400;
        line-height: 1;
        letter-spacing: 0;
        font-family: "TTNorms Font", Helvectica, sans-serif;
        letter-spacing: 0.0175rem;
        font-weight: 500;
        border-radius: 1rem;
        font-size: 0.875rem;
        line-height: 1.25rem;
        transition: all 0.6s;
        opacity: 0;
      }

      

      @media only screen and (min-width: 1100px) {
        .o-form__label-text {
          font-size: 1rem;
          letter-spacing: 0.02rem;
          line-height: 1.5rem;
        }
      }
      @media only screen and (min-width: 1750px) {
        .o-form__label-text {
          letter-spacing: 0.025rem;
          font-size: 1.25rem;
          line-height: 1.75rem;
        }
      }

      
      .o-form__label input,
      .o-form__label select,
      .o-form__label textarea {
        transition: all 0.6s;
      }
      .o-form__label:focus-within input,
      .o-form__label:focus-within select,
      .o-form__label:focus-within textarea {
        margin-top: 2.25rem;
      }
      .o-form__label:focus-within .o-form__label-text {
        top: 0.25rem;
        left: 0;
        opacity: 0.5;
      }
      .o-form__label textarea:not(:-moz-placeholder-shown), .o-form__label input:not(:-moz-placeholder-shown) {
        margin-top: 2.25rem;
      }
      .o-form__label textarea:valid,
      .o-form__label select:valid,
      .o-form__label input:valid,
      .o-form__label textarea:not(:placeholder-shown),
      .o-form__label input:not(:placeholder-shown) {
        margin-top: 2.25rem;
      }
      .o-form__label textarea:not(:-moz-placeholder-shown) + .o-form__label-text, .o-form__label input:not(:-moz-placeholder-shown) + .o-form__label-text {
        top: 0.25rem;
        left: 0;
        opacity: 0.5;
      }
      .o-form__label textarea:valid + .o-form__label-text,
      .o-form__label select:valid + .o-form__label-text,
      .o-form__label input:valid + .o-form__label-text,
      .o-form__label textarea:not(:placeholder-shown) + .o-form__label-text,
      .o-form__label input:not(:placeholder-shown) + .o-form__label-text {
        top: 0.25rem;
        left: 0;
        opacity: 0.5;
      }
      
      
      @media only screen and (min-width: 1100px) {
        .o-form__label:focus-within input,
        .o-form__label:focus-within select,
        .o-form__label:focus-within textarea {
          margin-top: 0;
        }
        .o-form__label:focus-within .o-form__label-text {
          top: -2rem;
        }
        .o-form__label textarea:not(:-moz-placeholder-shown), 
        .o-form__label input:not(:-moz-placeholder-shown) {
          margin-top: 0;
        }
        .o-form__label textarea:valid,
        .o-form__label select:valid,
        .o-form__label input:valid,
        .o-form__label textarea:not(:placeholder-shown),
        .o-form__label input:not(:placeholder-shown) {
          margin-top: 0;
        }
        .o-form__label textarea:not(:-moz-placeholder-shown) + .o-form__label-text, 
        .o-form__label input:not(:-moz-placeholder-shown) + .o-form__label-text {
          top: -2rem;
        }
        .o-form__label textarea:valid + .o-form__label-text,
        .o-form__label select:valid + .o-form__label-text,
        .o-form__label input:valid + .o-form__label-text,
        .o-form__label textarea:not(:placeholder-shown) + .o-form__label-text,
        .o-form__label input:not(:placeholder-shown) + .o-form__label-text {
          top: -2rem;
        }
      }

    </style>

    <div class="customiser-size-picker" part="root">

      <label class="o-form__label">
        <input class="room-name" name="Room Name" placeholder="Room Name*" required>
        <div class="o-form__label-text">Room Name*</div>
        <div class="o-form__input-validation">Enter Your Room Name</div>
      </label>

      <size-picker
        min-drop="${min_drop}"
        max-drop="${max_drop}"
        min-width="${min_width}"
        max-width="${max_width}"
        hide-ratio
      ></size-picker>
    </div>
  `;


  return template;

}


export class CustomiserSizePicker extends HTMLElement {
  private min_drop:string = this.getAttribute('min-drop');
  private max_drop:string = this.getAttribute('max-drop');
  private min_width:string = this.getAttribute('min-width');
  private max_width:string = this.getAttribute('max-width');

  public dimension_config:DimensionSettings = {
    Width: {
      min: parseInt(this.getAttribute('min-width')),
      max: parseInt(this.getAttribute('max-width'))
    },
    Drop: {
      min: parseInt(this.getAttribute('min-drop')),
      max: parseInt(this.getAttribute('max-drop'))
    }
  }

  constructor() {
    super();

    if (!this.min_drop || !this.max_drop || !this.min_width || !this.max_width) {
      console.error('Need to provide all min and max values for this component', this);
    }

    const shadowRoot = this.attachShadow({ mode: 'open' });
    const template = generateMarkup({
      min_drop: this.min_drop,
      max_drop: this.max_drop,
      min_width: this.min_width,
      max_width: this.max_width
    })
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.roomNameEl = this.shadowRoot?.querySelector('.room-name');

    this.roomNameEl.addEventListener('input', this.handleRoomNameChange.bind(this));

    this.sizePicker = this.shadowRoot?.querySelector('size-picker');
  }

  handleRoomNameChange(e?:Event) {
    const evt = new CustomEvent('room_name_change', {
      detail: e?.target?.value || '',
      bubbles: true,
      composed: true
    });

    this.dispatchEvent(evt);
    if (e) {
      this.validateFields();
    }
  }

  reset(dimensionConfig:DimensionSettings) {
    // reset function isn't workign for some reason. need to check this out.
    this.dimension_config = dimensionConfig;
    this.sizePicker.reset(dimensionConfig);
    this.roomNameEl.value = '';
    this.handleRoomNameChange();
  }

  validateFields() {
    if (!this.roomNameEl.value) {
      this.roomNameEl.classList.add('is-invalid')
    } else {
      this.roomNameEl.classList.remove('is-invalid')
    }

    this.sizePicker.validateFields();
  }
}

if (!customElements.get('customiser-size-picker')) {
  customElements.define('customiser-size-picker', CustomiserSizePicker);
}